<template>
    <div class="version-file-download">
        <h2>请选择应用类型</h2>
        <div class="form-wrapper">
            <div class="form-item">
                <label class="form-item-label required">选择版本</label>
                <div class="form-item-content">
                    <bk-selector
                        :list="versionList"
                        :selected.sync="versionType"
                        @item-selected="onVersionSelect">
                    </bk-selector>
                </div>
            </div>
            <template v-if="versionType === 'communityCustomization'">
                <div class="form-item">
                    <label class="form-item-label required">用户代号</label>
                    <div class="form-item-content">
                        <input type="text" v-model="appCode" @input="onAppCodeInput">
                        <span v-if="errors.appCode" class="error-msg">请填写用户代号</span>
                    </div>
                </div>
                <div class="form-item">
                    <label class="form-item-label required">用户证书</label>
                    <div class="form-item-content">
                        <input type="file" class="upload-input" ref="userCredential" accept=".cert" @change="onFileChange">
                        <button :class="['bk-button', 'bk-primary', { 'is-loading': uploading }]" @click="onCredentialUpload">上传</button>
                        <span v-if="errors.userCredential" class="error-msg">请上传用户证书</span>
                    </div>
                </div>
            </template>
            <template v-if="versionType === 'enterpriseSpecial'">
                <div class="form-item">
                    <label class="form-item-label required">选择企业</label>
                    <div class="form-item-content">
                        <bk-selector
                            :list="enterpriseList"
                            :selected.sync="appCode"
                            :setting-key = "'company_code'"
                            :displayKey ="'company'"
                            @item-selected="errors.appCode = false">
                        </bk-selector>
                        <span v-if="errors.appCode" class="error-msg">请选择企业</span>
                    </div>
                </div>
            </template>
        </div>
        <div class="form-action">
            <a class="bk-button bk-primary" @click="confirm" title="确定">
                <span>确定</span>
            </a>
            <a class="bk-button" title="取消" @click="cancel">
                <span>取消</span>
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'version_file_download',
        props: {
            enterpriseList: {
                type: Array,
                default () {
                    return []
                }
            },
            userCertNeeded: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                versionList: [
                    {
                        id: 'communityCommon',
                        name: '社区通用'
                    },
                    {
                        id: 'communityCustomization',
                        name: '社区定制'
                    },
                    {
                        id: 'enterpriseSpecial',
                        name: '企业专用'
                    }
                ],
                versionType: 'communityCommon',
                appCode: 'blueking', // 社区通用的企业代号默认为 blueking
                userCredential: '',
                uploading: false,
                errors: {
                    appCode: false,
                    userCredential: false
                }
            }
        },
        watch: {
            userCertNeeded (val) {
                if (val) {
                    this.errors.userCredential = true
                } else {
                    this.errors.userCredential = false
                }
            }
        },
        methods: {
            onVersionSelect (val) {
                this.appCode = val === 'communityCommon' ? 'blueking' : ''
                this.userCredential = ''
                this.uploading = false
                this.$emit('update:userCertNeeded', false)
                this.errors = {
                    appCode: false,
                    userCredential: false
                }
            },
            onAppCodeInput () {
                this.$emit('update:userCertNeeded', false)
                this.errors.appCode = false
            },
            onCredentialUpload () {
                if (this.uploading) {
                    return
                }
                this.$refs.userCredential.click()
            },
            onFileChange (event) {
                const files = event.target.files || event.dataTransfer.files
                
                if (!files.length) {
                    this.errors.userCredential = true
                    return
                } else {
                    this.errors.userCredential = false
                }

                const params = new FormData()
                params.append('cert', files[0])

                this.uploading = true
                axios.post(myUrl + `packman/cert/upload/`, params, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then((res) => {
                    if (res.data.result) {
                        this.$emit('update:userCertNeeded', false)
                        this.userCredential = res.data.data.user_cert_path
                    }
                    this.uploading = false
                })
            },
            confirm () {
                if (this.uploading) {
                    return
                }
                const config = {
                    appCode: this.appCode
                }
                if (this.versionType === 'communityCustomization') {
                    config.params = {
                        user_cert_path: this.userCredential
                    }
                    if (this.appCode === '') {
                        this.errors.appCode = true
                        return
                    }
                    if (this.userCertNeeded) {
                        return
                    }
                } else if (this.versionType === 'enterpriseSpecial') {
                    if (this.appCode === '') {
                        this.errors.appCode = true
                        return
                    }
                }

                this.$emit('confirm', this.versionType, config)
            },
            cancel () {
                this.reset()
                this.$emit('cancel')
            },
            reset () {
                this.versionType = 'communityCommon'
                this.userCredential = ''
                this.uploading = false
                this.appCode = ''
                this.errors = {
                    appCode: false,
                    userCredential: false
                }
                this.$emit('update:userCertNeeded', false)
            }
        }
    }
</script>
<style lang="scss" scoped>
    h2 {
      font-size: 22px;
      color: #212232;
      text-align: center;
      line-height: 30px;
      padding: 0 0 20px 0;
    }
    input{
        height: 38px;
        border: 1px solid #e6e6e7;
        width: 100%;
        padding: 0 10px;
        color: #4f515e;
        border-radius: 3px;
        &:disabled{
        background: #fafafa;
        color: #cccccc;
        }
    }
    .upload-input {
        display: none;
    }
    .form-wrapper {
        width: 600px;
        .form-item {
            margin-bottom: 20px;
            font-size: 14px;
            .form-item-label {
                float: left;
                width: 100px;
                height: 36px;
                line-height: 36px;
                text-align: right;
                &.required::after {
                    content: '*';
                    color: #ff5656;
                    position: relative;
                    margin: 2px -7px 0 2px;
                    display: inline-block;
                    vertical-align: middle;
                }
            }
            .form-item-content {
                position: relative;
                margin-left: 120px;
                margin-right: 40px;
                text-align: left;
            }
            .error-msg {
                position: absolute;
                bottom: -20px;
                left: 0;
                font-size: 12px;
                color: #fd6154;
            }
        }
    }
    .form-action {
        margin: 30px 0;
        text-align: center;
        .bk-button {
            width: 110px;
            float: none;
            margin-right: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// version_file_download.vue?5d633704